import { useMutation } from '@tanstack/react-query'
import { useFeatureFlags } from '@node-space/hooks'
import { postConvertQuote, refreshConvertTransfer } from 'services/WalletsService'
import { Quote } from 'types/payments'
import { postConvert } from 'types/wallets'

export interface RefreshQuoteVariables {
  transferId: string
  payload: postConvert
}

export const useRefreshConvertQuoteMutation = () => {
  const { enableV3Convert } = useFeatureFlags()

  return useMutation({
    mutationFn: ({ transferId, payload }: RefreshQuoteVariables): Promise<Quote> =>
      enableV3Convert ? refreshConvertTransfer(transferId) : postConvertQuote(payload),
  })
}
